import { AiSuggestionKind } from '@/types/schema';

/**
 * Checks if the provided kind is a valid reference AI suggestion kind.
 * @param kind
 */
export function isValidReferenceAISuggestionKind(kind: AiSuggestionKind) {
  return (
    kind === AiSuggestionKind.OnboardingEntity ||
    kind === AiSuggestionKind.OnboardingTestamentaryEntity ||
    kind === AiSuggestionKind.OnboardingIndividual ||
    kind === AiSuggestionKind.OnboardingOrganization
  );
}
